import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ProjectItemList } from '@/features/projects/types';
import { ProjectViewCollapsable } from '@/features/projects';

type OpportunityCollapsableProps = {
  readonly projects: ProjectItemList[];
  readonly names?: string[];
  readonly opportunityId: string;
  readonly isPaid?: boolean;
  readonly belongsToMe: boolean;
};

const getProjectName = (names: string[] | undefined, index: number, t: any) => {
  return names && names[index] ? names[index] : t('Project') + ` ${index + 1}`;
};

export function OpportunityCollapsableProjects({
  projects,
  names,
  opportunityId,
  isPaid,
  belongsToMe,
}: OpportunityCollapsableProps) {
  const { t } = useTranslation(['opportunities']);
  const visibleProjects = belongsToMe ? projects : projects.filter((p) => p.status.name === 'published');

  const [expandedProjectIds, setExpandedProjectIds] = useState<string[]>(visibleProjects.map((p) => p.id));

  const toggleCollapsable = (projectId: string) => {
    setExpandedProjectIds(
      (prev) =>
        prev.includes(projectId)
          ? prev.filter((id) => id !== projectId)
          : [...prev, projectId]
    );
  };

  return (
    <>
      {visibleProjects.map((project, index) => (
        <div key={project.id}>
          <ProjectViewCollapsable
            projectId={project.id}
            opportunityId={opportunityId}
            isPaid={isPaid}
            isExpanded={expandedProjectIds.includes(project.id)}
            onToggle={() => toggleCollapsable(project.id)}
            title={getProjectName(names, index, t)}
          />
        </div>
      ))}
    </>
  );
}
